// ReportDetailsWrapper.jsx or .tsx
import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import DistributionListMaintenancePage from './DistributionListMaintenancePage'

const DistributionListItemsPageWrapper = (props) => {
  const params = useParams()
  const navigate = useNavigate()
  const outletContext = useOutletContext()

  return (
    <DistributionListMaintenancePage
      {...params}
      navigate={navigate}
      outletContext={outletContext}
      {...props}
    />
  )
}

export default DistributionListItemsPageWrapper
